/**
 * Narwhalia backend
 * Swagger API docs for Narwhalia Backend application
 *
 * OpenAPI spec version: 0.9
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PriceDto } from './priceDto'
export * from './priceDto'

export interface GlitterOfferBaseDto {
	/** glitter amount in the package */
	amount: number;
	/** Ext ID of the glitter package */
	id: string;
	/** The external id of the user */
	//ownerId?: string;
	/** in USD */
	price?: PriceDto;

	/** quantity of glitter package available for buying, unlimited if missing */
	remainingQty?: number;

	// local
	actualPrice?: number;

	noRemaining(): boolean;
}

export class GlitterOfferBaseDto {
	static mixin<T extends GlitterOfferBaseDto>(thiz: T): T {
		thiz.noRemaining = () => thiz.remainingQty != null && thiz.remainingQty < 1;
		return thiz;
	}
}